module.exports = __webpack_public_path__ + "img/shengcun3.cb257274.png";